import React from 'react';
import PropTypes from 'prop-types';

import Histogram from 'components/Histogram';

import SamplesSpecifications from 'components/SamplesSpecifications';

const NumericalComponent = props =>
  <div className="flex" id="bottom-pane">
    <div className="half mr-15" id="original-dataset">
      <div className="content-item">
        <div className="flex space-between">
          <p className="font-700 mb-10">
            Original Dataset’s Histogram
          </p>
        </div>

        <div className="mb-30">
          <Histogram
            fill="darkblue"
            xAxisLabel={props.parameterName}
            values={props.originalSampleValues}
            originalValues={props.randomSampleValues}
            isRelativeFrequency={false}
          />
        </div>

        <SamplesSpecifications
          {...props.originalSampleSummary}
          amountLabel="Total Number of Observations"
          meanLabel={`Mean of ${props.parameterName}`}
          stdevLabel={`Standard Deviation of ${props.parameterName}`}
        />
      </div>
    </div>

    <div className="half" id="sample-dataset">
      <div className="content-item">
        <div className="flex space-between">
          <p className="font-700 mb-10">
            Selected Sample’s Histogram
          </p>
        </div>

        <div className="mb-30">
          <Histogram
            xAxisLabel={props.parameterName}
            values={props.randomSampleValues}
            originalValues={props.originalSampleValues}
            isRelativeFrequency={false}
          />
        </div>

        <SamplesSpecifications
          {...props.randomSampleSummary}
          amountLabel="Sample's Number of Observations"
          meanLabel={`Sample's Mean for ${props.parameterName}`}
          stdevLabel={`Sample's Standard Deviation for ${props.parameterName}`}
        />
      </div>
    </div>
  </div>;

NumericalComponent.propTypes = {
  parameterName: PropTypes.string.isRequired,

  randomSampleSummary: PropTypes.object.isRequired,
  originalSampleSummary: PropTypes.object.isRequired,

  randomSampleValues: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.object.isRequired
  ]).isRequired,

  originalSampleValues: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.object.isRequired
  ]).isRequired
};

export default NumericalComponent;
